$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  createCountdownDivider();
});

$(window).load(function () {
  contentMarginTop();
});

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

// Creates a division between eventDate and eventName
function createCountdownDivider() {
  const divider = $('<div>', {
    class: 'event-divider',
  });

  $('#eventDates').after(divider);
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header').outerHeight();
    const topHeaderHeight = $('.top-header').outerHeight();
    const generalMessageHeight = $('.generalmessage').outerHeight();

    if ($('body').hasClass('saffireWindowScrolled')) {
      $('header').css('top', -(topHeaderHeight + generalMessageHeight) + 'px');

      if ($('body').hasClass('homepage')) {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 'px',
        );
      } else {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 15 + 'px',
        );
      }
    } else {
      $('header').css('top', '0');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + 15 + 'px');
      }
    }
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      updateContentMargin();
      clearInterval(interval);
    }
  }, 300);

  $(window).on('scroll', function () {
    updateContentMargin();
  });
}

// Hide the cartMenuLink if the number is zero
document.addEventListener('DOMContentLoaded', function () {
  const cartMenuLink = document.querySelector('.cartMenuLink');
  if (cartMenuLink && cartMenuLink.textContent.trim() === '0') {
    cartMenuLink.textContent = '';
  }
});
